import { useLocation, useHistory, Redirect } from 'quartz-routing/react-router';
import { EmbeddedContentPage } from '../components/EmbeddedContentPage';
import { Paths } from '../constants/Paths';
import { useAppDispatch } from '../redux';
import { completeInvoicePayment } from '../features/InvoicePayment/InvoicePaymentSlice';
import { jsx as _jsx } from "react/jsx-runtime";
export function PayInvoicePage() {
  const location = useLocation();
  const history = useHistory();
  const dispatch = useAppDispatch();
  const params = new URLSearchParams(location.search);
  const paymentUrl = params.get('url');
  if (!paymentUrl) {
    return /*#__PURE__*/_jsx(Redirect, {
      to: Paths.INVOICES
    });
  }
  return /*#__PURE__*/_jsx(EmbeddedContentPage, {
    src: paymentUrl,
    title: "Pay Invoice",
    breadcrumbs: [{
      label: 'payInvoice.breadcrumb.invoices',
      href: Paths.INVOICES
    }, {
      label: 'payInvoice.breadcrumb.payInvoice'
    }],
    subscreen: "pay-invoice",
    onMessage: msg => {
      if (msg.payload.type === 'SUCCESS' || msg.payload.type === 'SUCCESS_WITH_REDIRECT') {
        dispatch(completeInvoicePayment());
        history.push(Paths.INVOICES);
      }
    }
  });
}